import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, Signal, WritableSignal, signal } from '@angular/core';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BottomSheetService } from 'src/app/core/services/bottom-sheet.service';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { SearchComponent } from 'src/app/shared/components/bottom-sheets/search/search.component';
import { ComponentType } from '@angular/cdk/portal';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { SearchCostumComponent } from '../../../punti-campionamento/components/bottom-sheets/search-costum/search-costum.component';

@Component({
  selector: 'app-input-select-controlli-costum',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextComponent,
    MyButtonComponent
  ],
  templateUrl: './input-select-controlli-costum.component.html',
  styleUrl: './input-select-controlli-costum.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputSelectControlliCostumComponent implements OnInit {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() labelError?: string;
  @Input() icon?: string;
  @Input() placeholder: string = '';
  @Input() hint?: string;
  @Input() form!: FormGroup;
  @Input() type: string = 'text';
  @Input() class: string = '';
  @Input() list: Signal<any[]> = signal([]);
  @Input() searchComponentTemplate: ComponentType<any> = SearchCostumComponent;
  @Input() labelField!: string;
  @Input() idField?: string; //se impostato valorizza il field con questo campo, altrimenti valorizza con l'intero oggetto
  @Output() datoSelected: EventEmitter<any> = new EventEmitter<any>();
  selectForm!: FormGroup;

  constructor (
    private readonly fb: FormBuilder,
    private readonly bottomSheetService: BottomSheetService,
  ) {}

  ngOnInit(): void {
    this.selectForm = this.fb.group({
      value: [this.form.get(this.name)?.value, this.form.get(this.name)?.validator],
      [this.labelField]: [this.idField ? this.getLabelOfItem(this.form.get(this.name)?.value) : this.form.get(this.name)?.value[this.labelField], this.form.get(this.name)?.validator]
    })
    this.form.get(this.name)?.valueChanges.pipe(
      debounceTime(1000), // Aggiungi un ritardo prima di applicare il filtro
      distinctUntilChanged() // Filtra solo se il valore cambia rispetto al precedente
    ).subscribe((value) => {
      if (value) {
        this.selectForm.get('value')?.patchValue(value);
        this.selectForm.get('value')?.markAsDirty();
      } else {
        this.selectForm.reset();
      }
    });
    this.selectForm.get('value')?.valueChanges.subscribe((value) => {
      this.onUpdateValue(value);
    });
    this.selectForm.get(this.labelField)?.valueChanges.pipe(
      debounceTime(300), // Aggiungi un ritardo prima di applicare il filtro
      distinctUntilChanged() // Filtra solo se il valore cambia rispetto al precedente
    ).subscribe((value) => {
      this.onUpdateLabel(value);
    });
  }

  onUpdateLabel(labelValue: any) {
    const valueControl = this.selectForm.get('value');
    const value = (labelValue !== null) ? this.getValueOfItem(labelValue, this.labelField) : null;
    valueControl?.patchValue(value);
    valueControl?.markAsDirty();
  }

  onUpdateValue(value: any) {
    const formControl = this.form.get(this.name);
    if (formControl?.value !== value) {
      this.form.reset()
      formControl?.patchValue(value);
      formControl?.markAsDirty();
      this.form.get("controlloEsterno")?.setValue(false)
      this.form.get("controlloExtraPiano")?.setValue(false)
      this.datoSelected.emit(this.list().find((item) => value==item.uuid))
 
    }
    const labelControl = this.selectForm.get(this.labelField);
    const labelValue = this.idField ? this.getLabelOfItem(formControl?.value) : formControl?.value[this.labelField];
    if (labelControl?.value !== labelValue) {
      labelControl?.patchValue(labelValue);
      labelControl?.markAsDirty();
    }
  }

  getItemBy(value: any, field?: string) {
    return value ? this.list().find((item) => field ? item[field].toString().toLowerCase() === value.toString().toLowerCase() : item === value) : null
  }

  getValueOfItem(value: any, field?: string) {
    let item = this.getItemBy(value, field ?? this.idField)
    if (item) {
      return this.idField ? item[this.idField] : item
    } else {
      return null
    }
  }

  getLabelOfItem(value: any, field?: string) {
    let item = this.getItemBy(value, field ?? this.idField)
    if (item) {
      return item[this.labelField]
    } else {
      return null
    }
  }

  onSearchClick() {
    const bottomSheetRef = this.bottomSheetService.open(this.searchComponentTemplate, {
      data: {
        list: this.list()
      }
    });
    bottomSheetRef.afterDismissed().subscribe((value) => {
      if (value) {
        const valueControl = this.selectForm.get('value');
        valueControl?.patchValue(this.idField ? value[this.idField] : value);
        valueControl?.markAsDirty()
      }
    })
  }

  isRequiredField(field: string) {
    const form_field = this.selectForm.get(field);
    if (!form_field?.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return (validator && validator['required']);
  }
}
